const NAMESPACE = 'SCHEDULE';

const SET_SCHEDULE = `${NAMESPACE}/SCHEDULE`;

export {
    SET_SCHEDULE,
};

export default NAMESPACE;
